import { ChangeEvent, ChangeEventHandler, KeyboardEventHandler, useEffect, useState } from "react";


interface CartQtyInputProps {
  qty: number;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onKeyUp: KeyboardEventHandler<HTMLInputElement>;
  lockUi?: boolean;
}

export default function CartQtyInput(props: CartQtyInputProps) {
  let [value, setValue] = useState<number>(props.qty);

  useEffect(() => {
    setValue(props.qty);
  }, [props.qty]);

  const internalOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (isNaN(parseInt(e.target.value))) {
      return;
    }
    setValue(parseInt(e.target.value));
    props.onChange(e);
  }

  return (
    <input className="input input-sm md:input-md join-item w-full" type="number" value={value} onChange={internalOnChange} onKeyUp={props.onKeyUp} {...(props.lockUi ? { disabled: true } : {})} />
  )
}
